export const DATA_HOOK = {
  root: 'buy-again',
  header: 'buy-again-header',
  list: 'buy-again-list',
  productCard: 'buy-again-product-card',
  productImage: 'buy-again-product-image',
  productName: 'buy-again-product-name',
  productPrice: 'buy-again-product-price',
  addToCart: 'buy-again-add-to-cart',
} as const;
